import { useEffect, useState } from "react";

export default function useWindowWidth() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));
  }, []);
  return [screenWidth];
}
